import { render, staticRenderFns } from "./BannersSection.vue?vue&type=template&id=182a7922"
import script from "./BannersSection.vue?vue&type=script&lang=js"
export * from "./BannersSection.vue?vue&type=script&lang=js"
import style0 from "./BannersSection.vue?vue&type=style&index=0&id=182a7922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports